
import { Component, Emit, Prop, Ref, Vue } from 'vue-property-decorator'
import { Observer } from 'mobx-vue'
import moment from 'moment'
import { EnumPlaybackStatus } from '@xt/client'

import ClasshourLive from './Live.vue'
import ClasshourHomework from './Homework.vue'
import ClasshourWenfang from './Wenfang.vue'
import ClasshourMaterial from './Material.vue'
import MaterialLinkPop from './MaterialLinkPop.vue'
import SelectReviewPop from './SelectReviewPop.vue'

import type { ClasshourDetail as TClasshourDetail, ClasshourMemberHomework, SelectReviewUI } from '@xt/client/entities/course-v2/types.d'

type ToggleSlideParams =
  | {
      type: 'homework-content'
      // 用户点击的作业id
      id: number
    }
  | {
      type: 'homework-submit'
    }

@Observer
@Component({
  components: {
    ClasshourLive,
    ClasshourHomework,
    ClasshourWenfang,
    ClasshourMaterial,
    MaterialLinkPop,
    SelectReviewPop
  }
})
export default class DetailMain extends Vue {
  @Prop({ required: true }) classhourDetail: TClasshourDetail

  @Ref()
  materialLinkPop: {
    open: (link: string) => void
    hide: () => void
  }

  @Ref()
  selectReviewPop: {
    open: (data: Array<SelectReviewUI>) => void
    hide: () => void
  }

  get EnumPlaybackStatus() {
    return EnumPlaybackStatus
  }

  get liveStartTime() {
    return moment(this.classhourDetail.classhourInfo.startTime).format('YYYY-MM-DD HH:mm')
  }

  get isPlayback() {
    return this.classhourDetail.classhourInfo.playbackStatus === EnumPlaybackStatus.Playback
  }

  handleOpenPop() {
    this.materialLinkPop.open(this.classhourDetail.classhourInfo.materialsStorageUrl!)
  }

  handleOpenSelectReviewPop(data: TClasshourDetail['homeworkTaskList'][number]) {
    if (!Array.isArray(data.memberHomeworks)) return

    const filter = data.memberHomeworks.filter(m => !m.reviewed && m.reviewedFlag === 0)

    const list = filter.map(item => ({
      id: item.id,
      cover: item.homeworkPicList[0]?.waterUrl,
      createTime: item.createTime,
      title: item.title || item.content || data.title
    }))

    this.selectReviewPop.open(list)
  }

  handleClickHomeworkItem(id: number) {
    this.$emit('toggle-next', { type: 'homework-content', id } satisfies ToggleSlideParams)
  }

  handleClickHomeworkTitle(id: number) {
    this.$emit('toggle-next', { type: 'homework-submit', taskId: id })
  }
}
